export const localeNumber = (num, locale = "nl") =>
  num.toLocaleString(locale, {
    minimumFractionDigits: 0
  });

export const getPublicPath = url => process.env.PUBLIC_URL + url;
